import { TFunction } from 'i18next'
import { z } from 'zod'

import { VisitorParkingPricingEntrySchema } from '@/models'

export const makeServiceFeeFormSchema = (t: TFunction<['parking-management']>) =>
  z.object({
    pricing: z.array(VisitorParkingPricingEntrySchema).superRefine((pricing, ctx) => {
      pricing.reduce<number | null>((lastEnabledNonZeroPrice, entry, index) => {
        if (!entry.enabled) {
          return lastEnabledNonZeroPrice
        }

        const currentPrice = Number(entry.price) || 0

        if (currentPrice === 0 && lastEnabledNonZeroPrice !== null) {
          ctx.addIssue({
            code: 'custom',
            message: t('parking-management:serviceFeeModal.validation.zeroAfterSet'),
            path: [index, 'price'],
          })
        } else if (
          currentPrice > 0 &&
          lastEnabledNonZeroPrice !== null &&
          currentPrice <= lastEnabledNonZeroPrice
        ) {
          ctx.addIssue({
            code: 'custom',
            message: t('parking-management:serviceFeeModal.validation.priceIncrease'),
            path: [index, 'price'],
          })
        }

        return currentPrice > 0 ? currentPrice : lastEnabledNonZeroPrice
      }, null)
    }),
  })

export type ServiceFeeFormData = z.infer<ReturnType<typeof makeServiceFeeFormSchema>>

export interface ServiceFeeModalProps {
  onClose: () => void
}
